<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="4">
          <div class="input-title">バリエーション</div>
        </el-col>
        <el-col :span="7">
          <el-select :value="sizeVariation" @change="changeVariations($event)">
            <el-option v-for="item in variations"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <template v-if="sizeVariation === '2'">
          <el-col :span="4">
            <div class="input-title">サイズ単位</div>
          </el-col>
          <el-col :span="7">
            <el-select v-model="sizeUnit" @change="$emit('changeSizeUnit', $event)">
              <el-option v-for="item in sizeunits"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </template>
      </el-row>
      <el-row>
        <el-table :data="sizeSelects">
          <el-table-column label="サイズ名" width="250">
            <template slot-scope="scope">
              <el-input :value="scope.row.name"
                        @input="sizeSelects[scope.$index].name=$event;$emit('change', sizeSelects)"
                        v-if="sizeVariation === '2'">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="参考日本サイズ" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.refId"
                         @change="sizeSelects[scope.$index].refId=$event;$emit('change', sizeSelects)">
                <el-option v-for="item in sizeReferences"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="サイズ詳細" width="100">
            <template slot-scope="scope">
              <size-detail-conf :detailList="sizeDetails"
                                :detailValues="sizeSelects[scope.$index].details"
                                @change="sizeSelects[scope.$index].details=$event;$emit('change', sizeSelects)">
              </size-detail-conf>
            </template>
          </el-table-column>
          <el-table-column v-if="sizeVariation === '2'" width="100">
            <template slot-scope="scope">
              <el-button size="mini"
                          icon="el-icon-delete"
                          @click="deleteSizeSelect(scope.$index)">
              </el-button>
            </template>
          </el-table-column>
          </el-table>
      </el-row>
      <el-row>
        <el-button v-if="sizeVariation === '2'" type="text" @click="addSizeSelect()">サイズ指定の追加</el-button>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import SizeDetailConf from '@/components/SizeDetailConf.vue'

export default {
  name: 'SizeConfig',
  components: {
    sizeDetailConf: SizeDetailConf
  },
  model: {
    prop: 'sizeSelects',
    event: 'change'
  },
  props: {
    sizeVariation: {
      type: String,
      default: '0'
    },
    sizeUnit: {
      type: String,
      default: '1'
    },
    sizeReferences: {
      type: Array
    },
    sizeDetails: {
      type: Array
    },
    sizeSelects: {
      type: Array
    }
  },
  data: function () {
    return {
      variations: [
        { id: '0', name: 'FREE SIZE' },
        { id: '1', name: 'ONE SIZE' },
        { id: '2', name: 'バリエーションあり' }
      ],
      sizeunits: [
        { id: '1', name: '指定なし' },
        { id: '2', name: 'cm' },
        { id: '3', name: 'inch' },
        { id: '4', name: '号' }
      ]
    }
  },
  methods: {
    changeVariations: function (variation) {
      let selects = null
      if (variation === '0') {
        selects = [
          this.createSizeSelect('f', 0)
        ]
      } else if (variation === '1') {
        selects = [
          this.createSizeSelect('o', 0)
        ]
      } else {
        selects = [
          this.createSizeSelect('', 0)
        ]
      }
      this.$emit('changeSizeUnit', '1')
      this.$emit('changeVariation', variation)
      this.$emit('change', selects)
    },
    addSizeSelect: function () {
      this.sizeSelects.push(this.createSizeSelect('', 0))
      this.$emit('change', this.sizeSelects)
    },
    createSizeSelect: function (name, refId) {
      var select = {
        name: name,
        refId: refId,
        details: []
      }
      for (var i = 0; i < this.sizeDetails.length; i++) {
        select.details.push({ id: this.sizeDetails[i].id, value: '' })
      }
      return select
    },
    deleteSizeSelect: function (index) {
      if (index === 0) {
        this.sizeSelects.shift()
      } else if (index === (this.sizeSelects.length - 1)) {
        this.sizeSelects.pop()
      } else {
        var sizeSelectsPre = this.sizeSelects.slice(0, index)
        this.sizeSelects = sizeSelectsPre.concat(this.sizeSelects.slice(index + 1, this.sizeSelects.length))
      }
      this.$emit('change', this.sizeSelects)
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
.el-select {
  width: 100%;
}
</style>
